import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const VolumeMuteIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "VolumeMute",
    children: /*#__PURE__*/_jsx("path", {
      d: "M18.29 29.44c.3.32.73.52 1.21.52h.03c.24 0 .47-.05.68-.14h-.01c.64-.27 1.08-.89 1.08-1.61v-9.99l-7.14 7.1 4.16 4.12ZM3.77 10.73v10.48c0 .8.56 1.47 1.3 1.66h.01l3.45-3.44 1.11-1.08L21.25 6.78V3.74c0-.72-.45-1.34-1.07-1.61h-.01c-.19-.08-.41-.13-.64-.13-.48 0-.91.19-1.23.51l-6.5 6.48H5.53c-.97 0-1.75.78-1.75 1.75ZM25.25 6 4.29 26.97c-.33.32-.53.76-.53 1.25s.2.93.53 1.25c.32.33.76.53 1.25.53s.93-.2 1.25-.53S27.73 8.44 27.73 8.44a1.767 1.767 0 1 0-2.5-2.5z"
    })
  }));
};